import React from 'react';
import { Navigate } from 'react-router-dom';

// Auth
import Login from '../modules/(identity)/pages/Login';
import Logout from '../modules/(identity)/pages/Logout';
import ResetPassw from '../modules/(identity)/pages/ResetPassw';
import Page404 from '../modules/(identity)/pages/Error404';
import OAuthCallback from '../modules/(identity)/pages/OAuthCallback';
import VerifyEmail from '../modules/(identity)/pages/VerifyEmail';
import AcceptInvitation from '../modules/(identity)/pages/AcceptInvitation';

// Páginas
import Dashboard from '../modules/(analytics)/pages/Dashboard';
import Report from '../modules/(analytics)/pages/Report';
import { UserPage, AuditLogPage, APIKeyPage, SupportPage } from '../modules/(admin)/pages';
import { AdvertiserPage, AgencyPage, AdNetworkPage, CampaignPage, OrderPage, CreativePage } from '../modules/(demand)/pages';
import { PublisherPage, PlacementPage, TagPage, SitePage, EditTagPage } from '../modules/(inventory)/pages';
import ForgetPasswordPage from '../modules/(identity)/pages/ForgetPassword';
import ExitImpersonation from '../modules/(identity)/pages/ExitImpersonation';
import Settings from '../modules/(identity)/pages/Settings';
import BlockedKeywords from '../modules/(protections)/pages';
import { SiteMonitorPage } from '../modules/(operations)/pages';
import { useProfile } from '../hooks/UserHooks';
import Integration from '../modules/(integrations)/pages/Integrations';
import { useScopes } from '../hooks/useScopes';
import { ApiScope } from '../types/api-scopes';
import { TagReportPage } from '../modules/(inventory)/pages';
import { PixelTagPage } from '../modules/(demand)/pages';

const Routes = () => {
    const { userProfile } = useProfile();
    const { hasScope } = useScopes();

    const authProtectedRoutes = [
        {
            path: '/',
            component: <Dashboard/>
        },
        // Companies
        {
            path: '/advertiser',
            component: hasScope(ApiScope.ADVERTISER_READ) ? <AdvertiserPage/> : <Navigate to="/"/>
        },
        {
            path: '/agency',
            component: hasScope(ApiScope.AGENCY_READ) ? <AgencyPage/> : <Navigate to="/"/>
        },
        {
            path: '/ad-network',
            component: hasScope(ApiScope.ADNETWORK_READ) ? <AdNetworkPage/> : <Navigate to="/"/>
        },
        {
            path: '/publisher',
            component: <PublisherPage/>
        },
        // Delivery
        {
            path: '/campaign',
            component: <CampaignPage/>
        },
        {
            path: '/order',
            component: <OrderPage/>
        },
        {
            path: '/creative',
            component: <CreativePage/>
        },
        // Inventory
        {
            path: '/site',
            component: <SitePage/>
        },
        {
            path: '/placement',
            component: <PlacementPage/>
        },
        {
            path: '/tag',
            component: <TagPage/>
        },
        {
            path: '/tag/new',
            component: <EditTagPage/>
        },
        {
            path: '/tag/:id/report',
            component: <TagReportPage/>
        },
        {
            path: '/tag/:id',
            component: <EditTagPage/>
        },
        // Protections
        {
            path: '/blocked-keywords',
            component: <BlockedKeywords/>
        },
        // Pixel Tags
        {
            path: '/pixel-tag',
            component: <PixelTagPage/>
        },
        // Admin
        {
            path: '/user',
            component: <UserPage/>
        },
        {
            path: '/audit-log',
            component: <AuditLogPage/>
        },
        {
            path: '/api-keys',
            component: <APIKeyPage/>
        },
        {
            path: '/support',
            component: <SupportPage/>
        },
        // Settings
        {
            path: '/pages-profile-settings',
            component: <Settings/>
        },
        // Integrations
        {
            path: '/integrations',
            component: <Integration/>
        },
        // Monitoring
        {
            path: '/site-monitor',
            component: hasScope(ApiScope.SITE_READ) ? <SiteMonitorPage/> : <Navigate to="/"/>
        },
        // Other routes
        {
            path: '/campaign/report/:campaignId',
            component: <Report/>
        },
        {
            path: '/exit-impersonation',
            component: <ExitImpersonation/>
        },
        // this route should be at the end of all other routes
        // eslint-disable-next-line react/display-name
        {
            path: '/',
            exact: true,
            component: <Navigate to="/campaign"/>,
        },
        { path: '*', component: <Page404/> },
    ];

    const publicRoutes = [
        // Authentication Page
        { path: '/logout', component: <Logout/> },
        { path: '/login', component: <Login/> },
        { path: '/forgot-password', component: <ForgetPasswordPage/> },
        { path: '/reset-password', component: <ResetPassw/> },
        { path: '/oauth/callback', component: <OAuthCallback/> },
        { path: '/verify-email', component: <VerifyEmail/> },
        { path: '/accept-invitation/:id', component: <AcceptInvitation/> },
    ];

    return { authProtectedRoutes, publicRoutes };
};

export default Routes;
